import { render } from "./ProductSelectionTrademarks.vue?vue&type=template&id=001c7124&scoped=true&ts=true"
import script from "./ProductSelectionTrademarks.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionTrademarks.vue?vue&type=script&lang=ts"

import "./ProductSelectionTrademarks.vue?vue&type=style&index=0&id=001c7124&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c7124"]])

export default __exports__